import { render, staticRenderFns } from "./editBack.vue?vue&type=template&id=9969f57c&scoped=true"
import script from "./editBack.vue?vue&type=script&lang=js"
export * from "./editBack.vue?vue&type=script&lang=js"
import style0 from "./editBack.vue?vue&type=style&index=0&id=9969f57c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9969f57c",
  null
  
)

export default component.exports